// theme/tableTheme.ts
import { tableAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(tableAnatomy.keys);

const roundedVariant = definePartsStyle({
  table: {
    bg: 'white',
    borderRadius: 'xl',
    overflow: 'hidden',
    borderWidth: '1px',
    borderColor: 'surface.300',
  },
  th: {
    bg: 'surface.200',
    color: 'primary.500',
    padding: '16px',
    borderRight: '1px solid',
    borderBottom: '1px solid',
    borderColor: 'surface.300',
    _last: {
      borderRight: 'none',
    },
  },
  td: {
    padding: '16px',
    borderRight: '1px solid',
    borderBottom: '1px solid',
    borderColor: 'surface.300',
    _last: {
      borderRight: 'none',
    },
  },
  tr: {
    _hover: {
      bg: 'surface.100',
    },
    _last: {
      td: {
        borderBottom: 'none',
      },
    },
  },
});

export const tableTheme = defineMultiStyleConfig({
  variants: {
    rounded: roundedVariant,
  },
});
